import { validate } from '@shared/validator/validator';
import { thirdPartyConstraints } from '@shared/validator/constraints/thirdPartyConstraints';
import { ClaimTypeTrigram } from '@shared/types/api/claim';
export const validateWithConstraintsByTypeTrigram = (validator, data, rootState) => {
    var _a, _b, _c;
    const typeTrigram = (_a = rootState.qualification) === null || _a === void 0 ? void 0 : _a.typeTrigram;
    const roomDamagesOrigin = typeTrigram === ClaimTypeTrigram.Glass && ((_b = rootState.qualification) === null || _b === void 0 ? void 0 : _b.qualification)
        ? (_c = rootState.qualification.qualification
            .roomDamagesOrigin) !== null && _c !== void 0 ? _c : undefined
        : undefined;
    const constraints = thirdPartyConstraints(typeTrigram, roomDamagesOrigin);
    validate(validator, data, constraints);
};
